import React from "react"
import Img from "gatsby-image"
import { BGCOLOR } from "utils/constants"
import styles from "./speaker.module.scss"

const Speaker = ({ content, img }) => {
  return (
    <div className={styles.speaker}>
      <div className={styles.speakerImage}>
        <Img
          fluid={img.childImageSharp.fluid}
          alt={content.img.alt}
          backgroundColor={BGCOLOR}
        />
      </div>
      <div className={styles.speakerBody}>
        <h6 className={styles.speakerOverline}>{content.type}</h6>
        <h3 className={styles.speakerName}>{content.name}</h3>
        <div className={styles.speakerBio}>{content.bio}</div>
      </div>
    </div>
  )
}

export default Speaker
